import "./toggle";
import "./checkout";
import { addToCart, removeFromCart } from "./update";
import { renderCartContent } from "./render";
import { addProductListeners, removeProductListeners } from "./event-listeners";


// Render cart on page load
document.addEventListener("DOMContentLoaded", () => {
    renderCartContent(); // Render cart content
    // Do this every second to make sure the cart content is always up to date
    setInterval(() => {
        addProductListeners(); // Add listeners to cart "add product" buttons
        removeProductListeners(); // Add listeners to cart "remove product" buttons
    }, 100);
});


// Check for query param 'reset-cart' and remove cookie 'f5-cart' of the query param is set to 1
if (window.location.search.includes("reset-cart=1")) {
    document.cookie = "f5-cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    renderCartContent(); // Render cart content
}